export default {
  subscribers: {
    title: "Абоненти",
    searchSubscribers: {
      modal: {
        title: "Параметри пошуку абонентів"
      },
      form: {
        abcode: "Оособовий рахунок",
        fio: "ПІБ абонента",
        region: "Район",
        street: "Вулиця",
        house: "Будинок",
        corpHouse: "Корпус будинку",
        flat: "Квартира",
        ncount: "№ лічильника",
        docnumber: "ІПН",
        eic: "EIC",
        dateBegin: "О/рахунок відкритий",
        dateEnd: "закритий",
        nact: "№ акту",
        accountNumber: "№ рахунку",
        fiofiz: "Прізвище фіз. особи",
        phone: "Телефон",
        numberhouses: "№ будинкового лічильника"
      }
    }
  }
};
